module.exports = __webpack_public_path__ + "static/media/member-photo-ezekiel-smigel.c32e071b.png";